import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageServerAction } from '../coverageServer.action';
import { CoverageServerTranslator } from '../coverageServer.translator';

type IDependencies = ICoverageApiDependencySegment;

export const createCoverageServerEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageServerAction.create.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi.createCoverageServer(CoverageServerTranslator.toApi(payload)).pipe(
      mergeMap((result) => {
        resolve(result.id);
        return [CoverageServerAction.create.done({ params, result: { serverId: result.id } })];
      }),
      catchApiError((error) => [
        CoverageServerAction.create.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
